import React, { useState, useEffect } from 'react';
import { getRequest } from '../apis/ApiInstence';
import AdminTable from 'common/AdminTable';

const PaymentList = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        // The getRequest already prefixes the baseUrl, so we just pass 'payment/list'
        const response = await getRequest('payment/list');
        setPayments(response.data);
      } catch (error) {
        console.error('Error fetching payments:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPayments();
  }, []);

  const tableHeaders = [
    { Header: 'Payment ID', accessor: 'payment_id' },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Phone', accessor: 'phone' },
    { Header: 'Email', accessor: 'email' },
    { Header: 'Course/Product', accessor: 'courseName' },
    { Header: 'Price', accessor: 'price' },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ row }) => (
        <span className={`badge ${row.original.status === 'succeeded' ? 'badge-success' : 'badge-danger'}`}>
          {row.original.status}
        </span>
      ),
    },
    { 
      Header: 'Date', 
      accessor: 'createdAt',
      Cell: ({ row }) => new Date(row.original.createdAt).toLocaleString()
    },
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Payments & Orders List</h4>
      </div>

      {loading ? (
        <div className="text-center mt-5"><div className="spinner-border text-primary" role="status"></div></div>
      ) : payments.length > 0 ? (
        <AdminTable tableHeaders={tableHeaders} tableData={payments} />
      ) : (
        <div className="text-center mt-5"><h5 className="text-white">No payments found.</h5></div>
      )}
    </div>
  );
};

export default PaymentList;
